import { Link } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';

interface LegalSection {
  heading: string;
  content?: string;
  list?: string[];
  after?: string;
  links?: string[];
  subsections?: { subheading: string; content?: string; list?: string[] }[];
}

const linkMap: Record<string, string> = {
  'Privacy Policy': '/privacy',
  'Cookie Policy': '/cookies',
  'Terms of Service': '/terms',
  'Politica de confidențialitate': '/privacy',
  'Politica de cookie-uri': '/cookies',
  'Termeni și condiții': '/terms',
};

const LegalPage = ({ pageKey }: { pageKey: 'privacy' | 'terms' | 'cookies' | 'gdpr' }) => {
  const { t } = useTranslation();
  const lp = t.legalPages;
  const page = lp[pageKey] as { title: string; sections: LegalSection[] };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '80px 24px 60px', fontFamily: 'var(--f-body)', color: 'var(--blue)', lineHeight: 1.8 }}>
      <Link to="/" style={{ color: 'var(--blue)', fontSize: 14, marginBottom: 24, display: 'inline-block' }}>{lp.backToSite}</Link>
      <h1 style={{ fontSize: 32, fontWeight: 800, color: 'var(--blue)', marginBottom: 8 }}>{page.title}</h1>
      <p style={{ color: 'var(--muted)', marginBottom: 32 }}>{lp.lastUpdated}</p>

      {page.sections.map((s, i) => (
        <div key={i}>
          <h2>{s.heading}</h2>
          {s.content && <p style={{ whiteSpace: 'pre-line' }}>{s.content}</p>}
          {s.subsections?.map((sub, j) => (
            <div key={j}>
              <h3>{sub.subheading}</h3>
              {sub.content && <p>{sub.content}</p>}
              {sub.list && <ul>{sub.list.map((item, k) => <li key={k}>{item}</li>)}</ul>}
            </div>
          ))}
          {s.list && <ul>{s.list.map((item, k) => <li key={k}>{item}</li>)}</ul>}
          {s.after && <p>{s.after}</p>}
          {s.links && (
            <ul>
              {s.links.map((label, k) => (
                <li key={k}><Link to={linkMap[label] || '#'}>{label}</Link></li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default LegalPage;
